import { omit } from "@common/helpers/objects";
import { FiltersTypes } from "@common/types/filters/general";
import { ActiveFilter, FilterTabs } from "@components/pageHeader/filters/lib";
import { getLockedActiveFilters } from "../shared/getLockedActiveFilters";
import { toCounterpartiesDirectoryQueryFilters } from "./counterpartiesDirectoryQuery";
import {
    PINNED_MEMBERSHIP_KEYS,
    TASK_SCOPE_KEYS,
} from "./counterpartiesTaskView";

export const ORG_LEVEL_COUNTERPARTIES_FILTER_TABS: FilterTabs[] = [
    FilterTabs.AMOUNT,
    FilterTabs.ELIGIBLE_1099,
    FilterTabs.JOURNAL_ENTRY_SOURCES,
    FilterTabs.LEDGER_GROUP,
    FilterTabs.COUNTERPARTY_CREATED_BY,
    FilterTabs.COUNTERPARTY_DISABLED,
];

export const WORKSPACE_COUNTERPARTIES_FILTER_TABS: FilterTabs[] = [
    FilterTabs.ACCOUNT,
    FilterTabs.LEDGER,
    FilterTabs.AMOUNT,
    FilterTabs.ELIGIBLE_1099,
    FilterTabs.JOURNAL_ENTRY_SOURCES,
    FilterTabs.LEDGER_GROUP,
    FilterTabs.COUNTERPARTY_CREATED_BY,
    FilterTabs.COUNTERPARTY_REVIEW,
    FilterTabs.COUNTERPARTY_DISABLED,
];

const PINNED_MEMBERSHIP_FILTER_TABS = new Set<FilterTabs>([
    FilterTabs.ELIGIBLE_1099,
    FilterTabs.COUNTERPARTY_REVIEW,
    FilterTabs.COUNTERPARTY_DISABLED,
]);

export const PINNED_COUNTERPARTIES_FILTER_TABS: FilterTabs[] =
    WORKSPACE_COUNTERPARTIES_FILTER_TABS.filter(
        (tab) => !PINNED_MEMBERSHIP_FILTER_TABS.has(tab),
    );

const LOCKABLE_FILTER_TABS = new Set<FilterTabs>(
    WORKSPACE_COUNTERPARTIES_FILTER_TABS,
);

export function getCounterpartiesLockedActiveFilters(
    originalFilters: FiltersTypes | undefined,
): ActiveFilter[] {
    return getLockedActiveFilters({
        lockableTabs: LOCKABLE_FILTER_TABS,
        originalFilters,
    });
}

export function toCounterpartiesTaskQueryFilters(filters: FiltersTypes) {
    return {
        ...toCounterpartiesDirectoryQueryFilters(filters),
        counterpartyReviewedFields: filters.counterpartyReviewedFields,
        counterpartyReviewedFieldsMode: filters.counterpartyReviewedFieldsMode,
        counterpartyUnreviewedFields: filters.counterpartyUnreviewedFields,
        counterpartyUnreviewedFieldsMode:
            filters.counterpartyUnreviewedFieldsMode,
        counterpartyReviewerIds: filters.counterpartyReviewerIds,
        counterpartyReviewerMode: filters.counterpartyReviewerMode,
        disabledFilter: filters.disabledFilter,
    };
}

export type CounterpartiesTaskQueryFilters = ReturnType<
    typeof toCounterpartiesTaskQueryFilters
>;

export function toPinnedCounterpartiesQueryFilters(
    filters: FiltersTypes,
): Partial<CounterpartiesTaskQueryFilters> {
    return omit(toCounterpartiesTaskQueryFilters(filters), [
        ...PINNED_MEMBERSHIP_KEYS,
    ]);
}

export function toCounterpartiesOverlayFilters(
    filters: FiltersTypes,
): FiltersTypes {
    return omit(filters, [...TASK_SCOPE_KEYS, "counterpartiesIds"]);
}
